import { Button,Paper, Dialog, DialogActions, DialogContent,TableRow,TableCell,TextField,TableContainer,Table,TableHead,TableBody, DialogTitle, Typography, Box } from '@mui/material';
import React, { useContext, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import formatValue from '../../../utils/formatNumber';
import { UserProfileContext } from '../UserProfile';
import Swal from 'sweetalert2';
import { ProviderServices } from '../CrudServices';
import Loading from '../../../components/Loader/Loading';
import useResponsive from '../../../hooks/useResponsive';

const EditServiceDialog = ({serviceData,onClose,openUpdateDialog}) => {
    const {isMd} = useResponsive();
    const {serviceDetailsData} = useContext(UserProfileContext);
    const {handleSubmit,control,formState:{isDirty}} = useForm({
        mode:'onChange',
        defaultValues:serviceData,
    })
    const [isSubmitted,setIsSubmitted] = useState(false);
    const handleServiceUpdate = async(data)=>{
        setIsSubmitted(true);
        const {servicesChildId,servicesMasterId,price,serviceTime,vistingCharge,...restall} = data;
        const updatedData = {
            servicesChildId,
            servicesMasterId,
            price,
            serviceTime,
            providerId:serviceDetailsData.providerId,
            vistingCharge,
        }
        try {
            const serviceUpdateResponse = await ProviderServices.updateProviderServices(updatedData,serviceData.id);
            if (serviceUpdateResponse.success == '1') {
                setIsSubmitted(false);
                Swal.fire('Success','Service Updated Successfully');
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Service Updated Successfully',
                    timer: 1500
                })
                onClose();
            } else {
                setIsSubmitted(false);
                Swal.fire('Error','Failed To Update Service');
            }
        } catch (error) {
            setIsSubmitted(false);
            Swal.fire("Error",'Something went wrong','error')
        }
    }
  return (
    <Dialog open ={openUpdateDialog}
        fullWidth={true} 
        maxWidth={isMd?'lg':"md"} 
        PaperProps={{
        sx: {
            width: {xs:'100%',md:'fit-content'}, 
            maxWidth: '100%' ,
            m:{xs:0,md:'auto'}
        },
        }}
    >
        {isSubmitted && <Loading/>}
        <Box component={'form'} onSubmit={handleSubmit(handleServiceUpdate)}>
            <DialogTitle sx={{borderBottom:'1px solid lightGray',p:'.5% 2%',bgcolor:'lightGray'}}>
                <Typography sx={{fontWeight:'600',fontSize:"0.85rem"}}>Edit Service</Typography>
            </DialogTitle>
            <DialogContent sx={{p:0}} >
                <TableContainer component={Paper}>
                    <Table size='small' sx={{ minWidth: 'max-content' }} aria-label="selected services table">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{fontWeight:'600'}}>Category</TableCell>
                                <TableCell sx={{fontWeight:'600'}}>Master Service</TableCell>
                                <TableCell align="center" sx={{ width: '1rem',fontWeight:'600' }}>Brand</TableCell>
                                <TableCell align="center" sx={{ width: '1rem',fontWeight:'600' }}>Time (min)</TableCell>
                                <TableCell align="center" sx={{ width: '1rem',fontWeight:'600' }}>Price</TableCell>
                                <TableCell align="center" sx={{ width: '1rem',fontWeight:'600' }}>Visiting Charge</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow >
                                <TableCell>{serviceData.subCategoryTitle}</TableCell>
                                <TableCell>{serviceData?.masterServiceTitle}</TableCell>
                                <TableCell align="center">{serviceData.brandTitle}</TableCell>
                                <TableCell align="right">
                                    <Controller
                                        name="serviceTime"
                                        control={control}
                                        rules={{
                                        required: 'Value is required',
                                        validate: (value) => {
                                            const intValue = parseInt(value, 10);
                                            return !isNaN(intValue) && intValue > 0 || 'Value should be a non-negative integer';
                                        }
                                        }}
                                        defaultValue={0}
                                        render={({ field, fieldState: { error } }) => (
                                        <TextField
                                            {...field}
                                            onChange={(e) => {
                                                const inputValue = e.target.value;
                                                let finalValue;
                                                if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
                                                finalValue = formatValue(inputValue);
                                                console.log("finalValue",finalValue)

                                                if(finalValue==''){
                                                    finalValue=0
                                                }

                                                field.onChange(finalValue);
                                                }
                                            }}
                                            type="number"
                                            inputMode="numeric"
                                            size="small"
                                            inputProps={{
                                                style: { textAlign: 'center', width: 'fit-content', height: '1rem',width:'3rem' },
                                                min: 0,
                                                step: 1, // Only allow whole numbers
                                                onFocus: (e) => e.target.select(), // This will auto-select all text on focus/click
                                                    onClick: (e) => e.target.select(),  // This ensures selection even on click when already focused 
                                                onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                                onKeyDown: (e) => {
                                                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                        e.preventDefault();
                                                    }
                                                }
                                            }}
                                            error={!!error}
                                        />
                                        )}
                                    />
                                </TableCell>
                                <TableCell align="right">
                                    <Controller
                                        name="price"
                                        control={control}
                                        rules={{
                                            required: 'Price is required',
                                            validate: (value) => {
                                                const floatValue = parseFloat(value);
                                                if (isNaN(floatValue)) return 'Please enter a valid number';
                                                if (floatValue > 0 && floatValue < 1) return 'Price should not be less than ₹1';
                                                return floatValue > 0 || 'Price should not be negative';
                                            }
                                        }}
                                        defaultValue={0}
                                        render={({ field, fieldState: { error } }) => (
                                            <TextField
                                                {...field}
                                                type="number"
                                               onChange={(e) => {
                                                    const inputValue = e.target.value;
                                                    let finalValue;
                                                    if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
                                                    
                                                    finalValue = formatValue(inputValue);
                                                    console.log("finalValue",finalValue)

                                                    if(finalValue==''){
                                                        finalValue=0
                                                    }
                                                        field.onChange(finalValue);
                                                    }
                                                }}
                                                inputMode="decimal"
                                                size="small"
                                                inputProps={{
                                                    style: { textAlign: 'center', width: 'fit-content', height: '1rem' },
                                                    min: 0,
                                                    step: 0.01, // Allow two decimal places
                                                    onFocus: (e) => e.target.select(), // This will auto-select all text on focus/click
                                                    onClick: (e) => e.target.select(),  // This ensures selection even on click when already focused 
                                                    onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                                    onKeyDown: (e) => {
                                                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                            e.preventDefault();
                                                        }
                                                    }
                                                }}
                                                error={!!error}
                                            />
                                        )}
                                    />
                                </TableCell>
                                <TableCell align="right" >
                                    <Controller
                                        name="vistingCharge"
                                        control={control}
                                        rules={{
                                            required: 'visitingCharge is required',
                                            validate: (value) => {
                                                const floatValue = parseFloat(value);
                                                if (isNaN(floatValue)) return 'Please enter a valid number';
                                                // if (floatValue >= 0 && floatValue < 1) return 'vistingCharge should not be less than ₹1';
                                                return floatValue >= 0 || 'vistingCharge should not be negative';
                                            }
                                        }}
                                        defaultValue={0}
                                        render={({ field, fieldState: { error } }) => (
                                            <TextField
                                                {...field}
                                                // disabled
                                                type="number"
                                                value={formatValue(field.value)}
                                                onChange={(e) => {
                                                    const inputValue = e.target.value;
                                                    let finalValue;
                                                    if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
                                                    
                                                    finalValue = formatValue(inputValue);
                                                    console.log("finalValue",finalValue)

                                                    if(finalValue==''){
                                                        finalValue=0
                                                    }                                           
                                                    field.onChange(finalValue);
                                                    }
                                                }}
                                                inputMode="decimal"
                                                size="small"
                                                inputProps={{
                                                    style: { textAlign: 'center', width: 'fit-content', height: '1rem' },
                                                    min: 0,
                                                    step: 0.01, // Allow two decimal places
                                                    onFocus: (e) => e.target.select(), // This will auto-select all text on focus/click
                                                    onClick: (e) => e.target.select(),  // This ensures selection even on click when already focused 
                                                    onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                                    onKeyDown: (e) => {
                                                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                            e.preventDefault();
                                                        }
                                                    }
                                                }}
                                                error={!!error}
                                            />
                                        )}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button size='small' disabled={!isDirty || isSubmitted} variant='contained' color='primary' type='submit' >Update</Button>
                <Button size='small' variant='contained' color='error' onClick={()=>onClose()}>Cancel</Button>
            </DialogActions>
        </Box>   
    </Dialog>
  );
}

export default EditServiceDialog;
